import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';

const initialState = {};

const composeEnhancers = typeof window === 'object'
  && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  }) : compose;

const middleware = [thunk];
const enhancer = composeEnhancers(
  applyMiddleware(...middleware),
);

//   // eslint-disable-next-line no-underscore-dangle
const store = createStore(rootReducer, initialState, enhancer);

export default store;
